import { useSyncExternalStore } from "react";

const MOBILE_BREAKPOINT = 768;
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

/**
 * Ekran mobil kenglikdami.
 *
 * `useSyncExternalStore` — aynan shu holat uchun mo'ljallangan primitiv:
 * `matchMedia` React'dan tashqaridagi manba, va uni `useState` +
 * `useEffect` bilan sinxronlashtirish birinchi renderdan keyin ortiqcha
 * qayta render hosil qiladi.
 *
 * Bu fayl shadcn CLI bergan versiyaning o'rniga qo'lda yozilgan —
 * `shadcn add` uni qayta yozib yuborishi mumkin, e'tibor bering.
 */
const subscribe = (onChange: () => void) => {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
};

export function useIsMobile(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    // Server tomonda `window` yo'q. Bu ilova SPA, lekin test muhitida
    // ham shu yo'l ishlatiladi — standart qiymat "mobil emas".
    () => false,
  );
}
